// libraries
import React from 'react';
import PropTypes from 'prop-types';

// shared
import Toast from 'shared/components/toast';
import Icon from 'shared/components/icon';
import TextButton from 'shared/components/text-button';

const propTypes = {
  action: PropTypes.object.isRequired,
  actionText: PropTypes.string.isRequired,
  dismiss: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  strongText: PropTypes.string,
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

const ActionNotification = ({dismiss, dispatch, text, type, strongText, actionText, action}) => (
  <Toast type={type} className='shared-notification-toast'>
    <span className="shared-notifications-message-text">
      {
        strongText &&
        <strong className="shared-notifications-message-text-strong">
          {`${strongText} `}
        </strong>
      }
      {`${text} `}
      <TextButton
        onClick={() => {
          dismiss();
          dispatch(action);
        }}
        color="white"
        className="shared-notifications-message-text-action-button"
      >
        {actionText}
      </TextButton>
    </span>
    <Icon
      iconType="times-r"
      className="shared-notifications-dismiss-notification-button"
      onClick={dismiss}
    />
  </Toast>
);

ActionNotification.propTypes = propTypes;

export default ActionNotification;
